import createApiRequest from '@/lib/axios/createApiRequest';

export default function deleteIWaveCredentials(ownerOrgId: string) {
  return createApiRequest({
    method: 'delete',
    path: `integrations/iwave/credentials?owner_org_id=${ownerOrgId}`,
    throwErrors: true,
  });
}
